export const PREMIUM_PLAN_PRODUCT_TYPE_ID = '8b1b47e6-9f58-4e59-b147-cac894bec8da';
export const WIXEL_PRODUCT_TYPE_ID = 'bd2de69a-4c3e-49c4-b5f3-e7362babc396';
export const WIXEL_MAX_PLAN_PRODUCT_FAMILY_ID = '839bb67c-ee9d-4e13-b316-44952bcac2e8';
export const WIXEL_PRO_PLAN_PRODUCT_FAMILY_ID = '29631a87-34f9-45ea-a08f-0098df462462';
export const ECLIPSE_PRODUCT_TYPE_ID = '8b1b47e6-9f58-4e59-b147-cac894bec8da';
export const ECLIPSE_LIGHT_PRODUCT_FAMILY_ID = '217fdefb-918b-46cb-8cfa-c010cbff46f9';
export const ECLIPSE_CORE_PRODUCT_FAMILY_ID = '1e543668-731b-4ec3-aaff-560dbca7ed69';
export const ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID = '5541f621-abdb-4b9c-ab54-95f6a10d3af1';
export const ECLIPSE_BUSINESS_ELITE_PRODUCT_FAMILY_ID = 'a60e81f8-6daa-4659-8ec5-5f47328a0d4c';
export const WIXEL_LIGHT_COUPON_PREFIX = '1yearfreelight';
export const GEOS = {
  US: 'US',
  BRAZIL: 'BR',
  JAPAN: 'JP'
};
export const LOCALES = {
  ENGLISH: 'en',
  PORTUGUESE: 'pt',
  JAPANESE: 'ja'
};
//# sourceMappingURL=consts.js.map